import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isDrawerOpen: false,
  items: {
    blocks: [],
    racks: [],
    nonLGV: [],
    lgvs: [],
  },
  filters: {
    location: null,
    sku: null,
    lpn: null,
    qualityStatus: null,
  },
  results: [],
  resultMessage: "",
  selectedResult: null,
  //if the results includes block rack nonLGV record toggles to true to higlight block rack nonLGV
  containsBlockRackNonLGV: false,
};

const inventorySlice = createSlice({
  name: "inventory",
  initialState,
  reducers: {
    setIsDrawerOpen: (state, action) => {
      state.isDrawerOpen = action.payload;
    },
    setBlocksData: (state, action) => {
      state.items.blocks = action.payload;
    },
    setRacksData: (state, action) => {
      state.items.racks = action.payload;
    },
    setNonLGVsData: (state, action) => {
      state.items.nonLGV = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setResults: (state, action) => {
      state.results = action.payload;
    },
    setResultMessage: (state, action) => {
      state.resultMessage = action.payload;
    },
    setSelectedResult: (state, action) => {
      state.selectedResult = action.payload;
    },
    setLGVsData: (state, action) => {
      state.items.lgvs = action.payload;
    },
    setContainsBlockRackNonLGV: (state, action) => {
      state.containsBlockRackNonLGV = action.payload;
    },
    reset: (state) => {
      state.filters.location = null;
      state.filters.sku = null;
      state.filters.lpn = null;
      state.filters.qualityStatus = null;
      state.results = [];
      state.selectedResult = null;
      state.resultMessage = "";
      state.containsBlockRackNonLGV = false;
    },
  },
});

export const {
  setIsDrawerOpen,
  setBlocksData,
  setRacksData,
  setNonLGVsData,
  setFilters,
  setResults,
  setResultMessage,
  setSelectedResult,
  reset,
  setLGVsData,
  setContainsBlockRackNonLGV,
} = inventorySlice.actions;

export default inventorySlice.reducer;
